<template>
    <div class="flex w-full">
        <div class="flex w-1/2">
            <select v-model="product" class="form-control">
                <option v-for="product in products" :value="product.slug" :key="product.slug">
                    {{ product.slug }} - {{ product.summary }}
                </option>
            </select>
        </div>

        <div class="flex ml-2">
            <div @click="handleNavigate" class="btn btn-yellow">Add Product</div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    products: {
        type: Array,
        required: true
    },
    user: {
        type: Object,
        required: true
    }
});

const product = ref('gbepas');

function handleNavigate() {
    window.location = window.route('admin.users.add-product', {
        user: props.user,
        productName: product.value
    });
}
</script>
